<template lang="pug">
v-dialog(v-model="dialogAdd" width="700" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-2(v-if="!itemIsNull" small color="blue" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-square-edit-outline
        v-btn.ml-10(v-else small color="green" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-plus-circle
            | &nbsp; Create User {{ type === 17 ? 'Group' : 'Label' }}

    v-card
        v-card-title {{ itemIsNull ? 'Create' : 'Update' }} Group
        v-card-text

            //- v-btn.ml-2.small.color="blue".dark(@click="openUserListingDialog") Select User

            v-text-field(label="Group Name" v-model="form.groupName" :disable="dialogAddLoading")

            v-text-field(label="Slug" v-model="form.slug" :disable="dialogAddLoading")

            v-dialog(v-if="currentUser === null" v-model="userListingDialog" width="700" persistent)
                template(v-slot:activator="{ on, attrs }")
                    v-btn.ml-2(dark small color="blue" v-bind="attrs" v-on="on")
                        v-icon(small) mdi-account-multiple
                        | &nbsp; Select Owner

                v-card
                    v-card-text(style="padding-top: 20px;")
                        user-listing(@select="selectUser")
                    v-divider
                    v-card-actions
                        v-spacer
                        v-btn(small color="red" text @click="userListingDialog = false") Cancel
            
            v-row(v-else)
                v-col(cols="12")
                    v-alert(type="info" border="left" colored-border elevation="2")
                        v-icon.mr-2 mdi-account
                        | Owner: {{ currentUser.fname }} {{ currentUser.lname }}

            v-row(style="padding: 10px;")
            v-row
                v-col(cols="12")
                    v-combobox(
                        v-model="form.genre"
                        :items="parseGenreLists(genreOptions)"
                        label="Select Genre"
                        :disable="dialogAddLoading"
                    )
            //- v-text-field(label="Name" v-model="form.name" :disable="dialogAddLoading")
            //- v-text-field(label="Description" v-model="form.description" :disable="dialogAddLoading")
            //- v-text-field(type="number" label="Points" v-model="form.points" :disable="dialogAddLoading")
            //- feathers-vuex-find(service="service-lists" :query="{}")
            //-     v-combobox(slot-scope="{ items }" v-model="form.hook" label="Target Service" :items="servicesFilter(items)" :disable="dialogAddLoading")
            //- v-combobox(v-model="form.hookType" label="Method" :items="methodOptions" :disable="dialogAddLoading")

        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!dialogAddLoading" small color="red" text @click="closeDialog") Cancel
            v-btn(small color="primary" text @click="addTrigger" :loading="dialogAddLoading") Submit
</template>

<script>
import { mapActions } from 'vuex';
import UserListing from './ListingComponent/UserListing.vue';

export default {
    props: {
        type: {
            type: Number,
            default: null
        },
        item: {
            type: Object,
            default() {
                return {
                    groupName: null,
                    userId: null,
                    genre: null,
                    slug: null
                };
            }
        }
    },
    data() {
        return {
            userListingDialog: false,
            dialogAdd: false,
            dialogAddLoading: false,
            currentUser: null,
            form: {
                groupName: this.item.groupName,
                userId: this.item.userId,
                genre: this.item.genre,
                slug: this.item.slug
            },
            successMessage: false,
            error: {
                show: false,
                message: ''
            },
            genreOptions: []
        };
    },
    computed: {
        methodOptions() {
            return [
                { id: 'CREATE', text: 'Create' },
                { id: 'UPDATE', text: 'Update' }
            ];
        },
        itemIsNull() {
            return !this.item || !this.item.name && !this.item.description;
        }
    },
    created() {
        this.getAllGenre({
            query: { $limit: 100 }
        }).then(res => {
            this.genreOptions = res.data;
        });
    },
    methods: {
        parseGenreLists(items) {
            return items.map(item => {
                return {
                    id: item.id,
                    text: item.genre
                };
            })
        },
        openUserListingDialog() {
            this.userListingDialog = true;
        },
        selectUser(user) {
            this.currentUser = user;
            this.form.userId = user.id;
            this.userListingDialog = false;
        },
        closeDialog() {
            this.dialogAdd = false;
            this.userListingDialog = false;
            this.currentUser = null;
        },
        async addTrigger() {
            try {
                await this.saveUserGroup({
                    group_name: this.form.groupName,
                    owner_id: this.form.userId,
                    slug: this.form.slug,
                    parent: this.type,
                    survey_option_tree: 1
                });
                // if(this.type === 17) {
                    await this.$store.dispatch('vw-user-labels/clearAll');
                    await this.$store.dispatch('vw-user-labels/find', { query: { $limit: 100 } });
                    await this.$store.dispatch('vw-user-groups/clearAll');
                    await this.$store.dispatch('vw-user-groups/find', { query: { $limit: 100 } });
                    this.$emit('success');
                    this.dialogAdd = false;
                // }
            } catch(err) {
                this.$emit('error', err)
            }
        },
        servicesFilter(items) {
            return [
                'authentication',
                ...(items.map(i => i.id).filter(service => [
                    'logic-control',
                    'cities',
                    'countries',
                    'regions',
                    'logic-control-category',
                    'bh-app-error-log',
                    'bh-app-version',
                    'bh-exp-tables',
                    'access-control-services',
                    'bh-user-obtained-exp',
                    'bh-exp-hooks'
                ].indexOf(service) === -1))
            ];
        },
        ...mapActions('bh-points-map', { createPointTrigger: 'create' }),
        ...mapActions('bh-mgenre', { getAllGenre: 'find' }),
        ...mapActions('bh-user-groups', { saveUserGroup: 'create' })
    },
    components: {
        UserListing
    }
}
</script>